// 언어 목록은 src/i18n/locales.ts 에 있다. 기존 import 경로를 살리려고 다시 내보낸다.
// 면책 문구는 번역 대상이라 src/i18n/messages/*.json 의 disclaimer 키로 옮겼다.
export { LOCALES, type Locale } from '../i18n/locales'

/** 오행. 색 토큰 이름과 키를 맞춰 둔다 (var(--wood) 등). */
export const ELEMENTS = ['wood', 'fire', 'earth', 'metal', 'water'] as const
export type Element = (typeof ELEMENTS)[number]

/** 타로 주제 키 — docs/tarot_major_ko.json 의 topics 와 같아야 한다. */
export const TAROT_TOPICS = [
  'love_single',
  'love_dating',
  'love_married',
  'work',
  'business',
  'study',
  'family',
  'self',
] as const
